export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=soft%20minimal%20abstract%20fashion%20background%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20delicate%20textile%20textures%2C%20light%20beige%20and%20soft%20coral%20accents%2C%20subtle%20organic%20flowing%20shapes%2C%20no%20text%2C%20no%20logos%2C%20elegant%20editorial%20design%20background%2C%20soft%20diffused%20morning%20light&width=1800&height=900&seq=oopbuy-hero-bg-02&orientation=landscape"
        alt="OOPBuy Spreadsheet Hintergrund"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="text-background-50 text-xs md:text-sm font-medium">Die deutsche Informationsplattform</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-6">
          OOPBuy Spreadsheet Deutschland – Finde die besten Produkte schneller
        </h1>

        <p className="text-background-50/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Entdecke aktuelle OOPBuy Spreadsheet Listen, Produktvergleiche und Experten-Guides. Spare Zeit bei der Produktsuche und finde geprüfte Produkte einfacher.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-sm md:text-base font-semibold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            OOPBuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 border border-background-50/30 px-8 py-3.5 rounded-full text-sm md:text-base font-semibold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-10 text-background-50/70 text-xs md:text-sm">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Aktualisierte Spreadsheet Listen
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Deutsche Schritt-für-Schritt Anleitungen
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Produktvergleiche mit Tabellen
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-check-line text-accent-400"></i> Sicherheitsinformationen
          </span>
        </div>
      </div>
    </section>
  );
}